export const verificationMethods = {
  RECIPROCATE_QR_CODE: "m.reciprocate.v1",
  SHOW_QR_CODE_METHOD: "m.qr_code.show.v1",
  SAS: "m.sas.v1",
};
